import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const EditSite = ({
  selectedSite,
  showEditSiteModal,
  handleEditSiteModalDisplay,
  handleEditSite,
}) => (
  <>
    <Button
      size="sm"
      variant="primary"
      onClick={() => {
        handleEditSiteModalDisplay(true);
      }}
    >
      Edit Site
    </Button>

    <Modal
      show={showEditSiteModal}
      onHide={() => {
        handleEditSiteModalDisplay(false);
      }}
    >
      <Modal.Header>
        <Modal.Title className="m-0">Edit Site</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            handleEditSiteModalDisplay(false);
          }}
        />
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          siteId: selectedSite._id,
          siteName: selectedSite.siteName,
        }}
        validationSchema={Yup.object({
          siteName: Yup.string().required('Enter site name'),
          siteAddress: Yup.string()
            .min(10, 'Site address must be more than 10 characters')
            .max(300, 'Site address must be less than 500 characters'),
        })}
        onSubmit={(values) => {
          handleEditSite(values);
        }}
      >
        {(formikprops) => (
          <Form onSubmit={formikprops.handleSubmit}>
            <Modal.Body>
              <section>
                <Form.Group controlId="worksessionType">
                  <Form.Label>Country</Form.Label>
                  <Field
                    className="form-control form-select"
                    as="select"
                    name="country"
                    placeholder="Select"
                    disabled
                  >
                    <option value="">{selectedSite.countryName}</option>
                  </Field>

                  <ErrorMessage
                    name="country"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
                <Form.Group controlId="siteName">
                  <Form.Label>Site name</Form.Label>
                  <Field
                    className="form-control"
                    type="text"
                    placeholder="Enter site name"
                    name="siteName"
                  />
                  <ErrorMessage
                    name="siteName"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
              </section>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button
                variant="link"
                onClick={() => {
                  handleEditSiteModalDisplay(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Update
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  </>
);

EditSite.propTypes = {
  selectedSite: PropTypes.object,
  showEditSiteModal: PropTypes.bool,
  handleEditSiteModalDisplay: PropTypes.func,
  handleEditSite: PropTypes.func,
};

export default EditSite;
